import { render, staticRenderFns } from "./ChatInfoUser.vue?vue&type=template&id=d2702ec6&scoped=true&"
import script from "./ChatInfoUser.vue?vue&type=script&lang=ts&"
export * from "./ChatInfoUser.vue?vue&type=script&lang=ts&"
import style0 from "./ChatInfoUser.vue?vue&type=style&index=0&id=d2702ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2702ec6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemAction,VListItemContent})
